import { useEffect } from 'react';

import { useHeaderStore } from 'state/headerStore';

const useSideMenuScroll = () => {
  const { isSideMenuOpen, setHeaderSettings } = useHeaderStore();

  useEffect(() => {
    const scrollContainer = document.getElementById('side_menu_wrapper');

    if (!scrollContainer || !isSideMenuOpen) return;

    const handleScroll = () => {
      const scrollTop = scrollContainer.scrollTop;
      setHeaderSettings({ headerOffset: scrollTop });
    };

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [isSideMenuOpen, setHeaderSettings]);
};

export default useSideMenuScroll;
